<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <el-form-item  prop="vc_keyname" label="模板名称" required>
                <div style="min-width: 200px" v-if="!canEdit" class="mrA">{{formData.vc_keyname}}</div>
                <el-input
                        style="min-width: 200px"
                        v-else
                        size="mini"
                        class="input"
                        placeholder="输入模板名称"
                        v-model="formData.vc_keyname"
                        clearable>
                </el-input>
            </el-form-item>
            <el-form-item  prop="vc_table" label="关联业务表名" required>
                <div style="min-width: 200px" v-if="!canEdit" class="mrA">{{formData.vc_table}}</div>
                <el-input
                        style="min-width: 200px"
                        v-else
                        size="mini"
                        class="input"
                        placeholder="输入关联业务表名"
                        v-model="formData.vc_table"
                        clearable>
                </el-input>
            </el-form-item>

            <div style="margin-bottom: 10px">
                <el-table class="table"
                        border :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="filterData"
                        :height="tableHeight"
                        size="mini"
                        tooltip-effect="dark"
                        >
                    <el-table-column prop="vc_column" label="数据库字段" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-input class="changeinput" @change="changeData(scope.row)" size="mini" v-if="canEdit" v-model="scope.row.vc_column"></el-input>
                            <span v-else>{{scope.row.vc_column}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vc_columntype" label="数据库类型" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-select   v-if="canEdit" v-model="scope.row.vc_columntype" @change="changeData(scope.row)" size="mini">
                                <el-option
                                        v-for="item in vc_columntypeList"
                                        :key="item.type"
                                        :label="item.type"
                                        :value="item.type">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.vc_columntype}}</span>

                        </template>
                    </el-table-column>
                    <el-table-column prop="reversalFlag" label="是否回冲账务时间标识" show-overflow-tooltip>
                        <template slot-scope="scope"  v-if="scope.row.vc_columntype=='datetime'">
                                <template v-if="canEdit">
                                    <el-radio v-model="scope.row.reversalFlag" :label="0" >否</el-radio>
                                    <el-radio v-model="scope.row.reversalFlag" :label="1">是</el-radio>
                                </template>
                                <span v-else>{{scope.row.reversalFlag==1?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vc_default" label="默认值" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-input class="changeinput" @change="changeData(scope.row)" size="mini" v-if="canEdit" v-model="scope.row.vc_default"></el-input>
                            <span v-else>{{scope.row.vc_default}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="i_type" label="字段类型" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-select v-model="scope.row.i_type" @change="changeData(scope.row)" v-if="canEdit" size="mini">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{typeList.find(t=>t.value==scope.row.i_type).text}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="vc_head" label="excel列名/表达式" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-input class="changeinput" v-if="canEdit" size="mini" v-model="scope.row.vc_head" @change="changeData(scope.row)" ></el-input>
                            <span v-else>{{scope.row.vc_head}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vc_columnformat" label="时间格式" show-overflow-tooltip>
                        <template slot-scope="scope"  >
                            <el-select v-if="canEdit" v-model="scope.row.vc_columnformat" @change="changeData(scope.row)" size="mini" clearable>
                                <el-option
                                        v-for="item in timeList"
                                        :key="item.text"
                                        :label="item.text"
                                        :value="item.text">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.vc_columnformat}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  width="50" label="操作" align="center">
                        <template slot="header" slot-scope="scope" v-if="canEdit">
                            <el-button  icon="el-icon-plus"  @click="addRow"   size="mini" v-if="canEdit" type="text" ></el-button>

<!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                        </template>
                        <template slot-scope="scope" v-if="canEdit">
                            <div style="text-align: center !important;">
                                <el-button  icon="el-icon-minus"  type="text" @click="deleteRow(scope.row,scope.$index)"  size="mini" class="mrl10" ></el-button>

                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span style="font-size: 12px;color: dimgray">表达式格式:@前段参数名@，"{}"用来获取字段，"+"连接字符,支持三目运算。<br/>
                例:"@vc_gsaccount@-"+"{对方账号}-"+"{交易时间}-"+"{余额}"；{转入金额}>0?{转入金额}:{转出金额}。</span>

            <div class="formDiv flex jcsb">
                <el-form-item class="form-title" prop="vc_creator" label="录入人" >
                    <span>{{formData.vc_creator}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">保存</el-button>
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
            </template>
            <el-button type="primary" @click="copysaveForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">复制</el-button>

            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                canEdit:true,
                formData:{
                    vc_keyname:'',
                    vc_table:'',
                    vc_creator:'',
                    dt_createtime:'',
                },
                tableData:[],
                tableHeight:0,
                typeList:[{text:'excel列名',value:0},{text:'表达式',value:1}],
                timeList:[{text:'yyyy-MM-dd'},{text:'dd/MM/yyyy'},{text:'MM-dd-yyyy'},{text:'yyyyMMdd'},{text:'dd-MM-yyyy'},{text:'yyyy/MM/dd'},{text:'yyyy/MM/d'},{text:'dd MM yyyy'},{text:'yyyy-MM-dd HH:mm:ss'}],
                disabled:false,
                baseerp:'',
                vc_columntypeList:[
                    {type:'varchar',text:'varchar'},
                    {type:'datetime',text:'datetime'},
                    {type:'decimal',text:'decimal'},
                    {type:'int',text:'int'},
                ],
                liList:[
                    {i_id:425,text:`"@vc_gsaccount@-"+"{对方账号}-"+"{交易时间}-"+"{余额}"`,vc_column:'vc_keyno'},
                    {i_id:429,text:`{转入金额}>0?{转入金额}:{转出金额}`,vc_column:'f_pay'},
                    {i_id:432,text:`"@vc_gsaccount@"`,vc_column:'vc_gsaccount'},
                    {i_id:434,text:`"@vc_gsname@"`,vc_column:'vc_gsname'},
                    {i_id:487,text:`1或0`,vc_column:'i_isuse'},
                    {i_id:489,text:`@i_bzid@`,vc_column:'i_bzid'},
                    {i_id:490,text:`@i_gsid@`,vc_column:'i_gsid'},
                    {i_id:490,text:`@f_rate@`,vc_column:'f_rate'},
                    {i_id:492,text:`{转入金额}>0?1:0`,vc_column:'c_type'},
                    {i_id:493,text:`@i_lruid@`,vc_column:'i_lruid'},
                    {i_id:494,text:`"@vc_lruname@"`,vc_column:'vc_lruname'},
                ],
                i_id:0,
            }
        },
        computed:{
            filterData(){
                return this.tableData.filter(t=>t.i_state!=-1)
            },
        },
        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(this.i_id==0){
                            this.canEdit=true;
                            this.formData.i_id=this.i_id;
                            this.formData.vc_keyname='';
                            this.formData.vc_table='';
                            this.formData.vc_creator=sessionStorage.getItem("lruname");
                            this.formData.i_creator=sessionStorage.getItem("userid");
                            this.getDateYYYYMMddHHMMSS();
                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data));
                            this.getExcelTempDetails();
                            this.canEdit=false;
                        }
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;

            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            editForm(){
                this.canEdit=true
            },
            changeData(item){
                item.change='change'
                this.$forceUpdate()
            },
            copysaveForm(){
                this.formData.i_id=0;
                this.formData.vc_keyname=this.formData.vc_keyname+'-copy'
                this.tableData.map(d=>{
                    d.i_state=1
                    delete d.i_id
                    delete d.i_pid
                    }
                );
                this.canEdit=true
            },
            saveForm(){
                if(this.formData.i_id==0){
                    this.addExcelTemp()

                }else{
                    this.editExcelTemp()

                }
                this.disabled=true
            },
            addRow(){
                this.tableData.unshift({
                    i_state:1,
                    vc_head:'',
                    i_type:'',
                    vc_column:'',
                    vc_columntype:'',
                    vc_default:'',
                    reversalFlag:0,
                })
            },
            deleteRow(val,i){
                if(val.i_id){
                    val.i_state=-1
                }else{
                    this.tableData.splice(i,1)
                }
                // this.tableData.splice(index,1)
            },
            cancel(){
                this.$emit('close')
            },
            async getExcelTempDetails(){
                let param={
                    i_pid:this.i_id
                };
                let res=await API.getExcelTempDetails(param);
                if ( res.code == 1 ){
                    // this.i_id=res.data.i_id;
                    this.tableData=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async addExcelTemp(){
                if(this.formData.vc_keyname==''){
                    this.$message.warning('请填写模板名称');
                    return
                }
                if(this.formData.vc_table==''){
                    this.$message.warning('请填写关联业务表名');
                    return
                }
                this.formData.vc_creator=sessionStorage.getItem("lruname");
                this.formData.i_creator=sessionStorage.getItem("userid");
                let form=this.formData;
                form.list=this.tableData;
                let param=form;
                let res=await API.addExcelTemp(param);
                if ( res.code == 1 ){
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            async editExcelTemp(){
                if(this.formData.vc_keyname==''){
                    this.$message.warning('请填写模板名称');
                    return
                }
                if(this.formData.vc_table==''){
                    this.$message.warning('请填写关联业务表名');
                    return
                }
                this.formData.vc_creator=sessionStorage.getItem("lruname");
                this.formData.i_creator=sessionStorage.getItem("userid");
                let form=this.formData;
                form.list=this.tableData.filter(t=>t.change=='change'||t.i_state==-1);
                let param=form;
                let res=await API.editExcelTemp(param);
                if ( res.code == 1 ){
                    this.$emit('close','save');
                    this.disabled=false

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
.flex{
    display:flex;
}
    .jcsb{
        justify-content: space-between;

    }
    /deep/{
        .el-radio{
            margin-right: 5px;
        }
    }
</style>